module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_75_100.e47d2ea2.png";